import moment from "moment";

export default {
	momentCache: {},
	internalCreateMoment(string){
		if(string == null)
			return moment(new Date());

		return moment(string);
	},
	getMoment(string){
		if(string == null)
			return this.internalCreateMoment();

		if(this.momentCache[string] == null){
			this.momentCache[string] = {
				moment: this.internalCreateMoment(string)
			};
		}

		return this.momentCache[string].moment;
	},
	createMoment(string){
		if(string == null)
			return this.internalCreateMoment();

		return this.getMoment(string).clone();
	}
}